import { createContext, useState } from "react";
import useAuth from "../hooks/useAuth";
import useInvoice from "../hooks/useInvoice";
import useProduct from "../hooks/useProduct";
import useSubscription from "../hooks/useSubscription";


const Context = createContext();

function UserProvider({children}){
    const { authenticated, user, setUser, register, logout, login, fetchUser, editUser, changePlan, registerPdf, authUser } = useAuth();
    const { createInvoice, generateReceiptFromInvoice, revertReceiptToInvoice, getInvoiceById, getMyInvoices, getInvoicesByMonth, deleteInvoice, updateInvoiceStatus, getSummary,fetchSummary, summary, getInvoicesByYear, getAllInvoices, getStatistics } = useInvoice();
    const { createProduct, getMyProducts, getProductById, searchProducts, updateProduct, deleteProduct } = useProduct();
    const { subscribe, cancelSubscription, updateSubscription, getMySubscriptions, getPlans } = useSubscription();

    const [invoices, setInvoices] = useState([]);
    const [products, setProducts] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);

    return(
        <Context.Provider value={{
            // auth
            authenticated, user, setUser, register, logout, login, fetchUser, editUser, changePlan,registerPdf, authUser,
            // invoices
            createInvoice, generateReceiptFromInvoice, revertReceiptToInvoice, getInvoiceById, getMyInvoices, getInvoicesByMonth, deleteInvoice, updateInvoiceStatus, getSummary, fetchSummary, summary, invoices, setInvoices, 
            getInvoicesByYear, getAllInvoices, getStatistics,
            // products
            createProduct, getMyProducts, getProductById, searchProducts, updateProduct, deleteProduct,
            products, setProducts,
            // subscriptions
            subscribe, cancelSubscription, updateSubscription, getMySubscriptions, getPlans,
            subscriptions, setSubscriptions,
            }}>
            {children}
        </Context.Provider>
    )
}

export { Context, UserProvider };